import React, { useCallback, useRef } from 'react'
import { CircularProgress, makeStyles } from '@material-ui/core'
import SectionScreen from '../SectionScreen'
import { useClientDetails, useSectionEditing } from '../ClientDetailsFormContext'
import { useListClientKeyDatapoints, useModifyClientKeyDatapointValues } from '../../../../../api/groups'
import SectionHeader from '../../shared/SectionHeader'
import PersonalSpace from '../../shared/PersonalSpace'
import FadeIn from '../../../../molecules/Transitions/FadeIn'
import EditButton from '../EditButton'
import KdpDisplay from './KdpDisplay'

const useStyles = makeStyles((theme) => ({
  kdpSection: {
    position: 'relative',
    padding: '10px'
  },
  loading: {
    height: '300px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}))

function KdpSection () {
  const classes = useStyles()
  const { client, editSection } = useClientDetails()
  const editing = useSectionEditing('kdp')
  const { data, isLoading, isFetching } = useListClientKeyDatapoints(client.clientId)
  const formRef = useRef()
  const { mutateAsync: modifyKdps } = useModifyClientKeyDatapointValues()
  const onSave = useCallback(async (e) => {
    const onValid = async (formData) => {
      await modifyKdps({
        clientId: client.clientId,
        datapoints: Object.values(formData.datapoints)
      })
    }

    const onInvalid = (errors) => {
      console.error(errors)
    }

    const handler = formRef.current.form.handleSubmit(onValid, onInvalid)
    await handler(e)
  }, [client, formRef, modifyKdps])

  if (isLoading) {
    return <div>Loading</div>
  }

  if (isFetching) {
    return (
      <FadeIn className={classes.loading}>
        <CircularProgress />
      </FadeIn>
    )
  }

  return (
    <SectionScreen sectionName='kdp' className={classes.kdpSection}>
      <SectionHeader text='Key Datapoint Values'>
        <div>
          <EditButton
            policy='admin_edit_key_datapoints'
            editing={editing}
            onClick={() => editSection({
              section: 'kdp',
              saveDescription: 'Save Key Datapoint Values',
              onSave
            })}
          />
        </div>
      </SectionHeader>
      <KdpDisplay ref={formRef} datapoints={data} editing={editing} />
      <PersonalSpace />
    </SectionScreen>
  )
}

export default KdpSection
